module.exports = __webpack_public_path__ + "media/img/ms-icon-70x70-70672466a219c0c33a35866b397a1fee.png";